import { useState, useEffect } from 'react';
import api from '../../services/api';

export const useAssessmentLibrary = () => {
  const [assessments, setAssessments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAssessments = async () => {
      try {
        setLoading(true);
        const response = await api.get('/admin/resources/assessments');
        setAssessments(response.data.data);
        setError(null);
      } catch (err) {
        setError(err);
        console.error('Error fetching assessments:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAssessments();
  }, []);

  return { assessments, loading, error };
};
